import { EmoticonFrownIcon } from './EmoticonFrownIcon';

/**
 * author: Michael Irigoyen
 * id D5AC778B-0269-4AC5-A2D8-FD5F4D27785F
 * name emoticon-frown
 * version: 3.9.97
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/emoticon-frown.svg
 * tags
 * - Emoji 
 */
export const FaceFrownIcon = EmoticonFrownIcon;
export default FaceFrownIcon